// import React, { useState } from 'react';
// // ✅ UPDATED: Import smart field types instead of old FIELD_TYPES
// import { SMART_FIELD_TYPES } from '../../config/field-validations';
// import COMPONENT_VALIDATIONS from '../../config/component-validations'; // ✅ FIX: Changed to default import
// // import { FIELD_TYPES, DATA_SOURCE_TYPES } from '../../config/formTemplates'; // ❌ OLD - Commented out
// import ActionSelector from '../ActionSystem/ActionSelector';
// import actionRegistry from '../ActionSystem/ActionRegistry';
// import '../ActionSystem/actions.css';

// const FormConfigPanel = ({ formConfig, onUpdateForm }) => {
//   const [showActionSelector, setShowActionSelector] = useState(false);
//   const [editingActionIndex, setEditingActionIndex] = useState(null);
//   const [editingActionType, setEditingActionType] = useState(null);
//   const [editingActionConfig, setEditingActionConfig] = useState(null);
  
//   // ✅ NEW: State for advanced validation popup
//   const [showAdvancedPopup, setShowAdvancedPopup] = useState(false);
//   const [activeFieldIndex, setActiveFieldIndex] = useState(null);
  
//   // ✅ FIX: State for tooltip
//   const [tooltipVisible, setTooltipVisible] = useState({});
  
//   const updateFormField = (path, value) => {
//     const newConfig = { ...formConfig };
//     const keys = path.split('.');
//     let current = newConfig;
    
//     for (let i = 0; i < keys.length - 1; i++) {
//       if (!current[keys[i]]) current[keys[i]] = {};
//       current = current[keys[i]];
//     }
    
//     current[keys[keys.length - 1]] = value;
//     onUpdateForm(newConfig);
//   };

//   const updateField = (fieldIndex, fieldPath, value) => {
//     const newFields = [...formConfig.fields];
//     const keys = fieldPath.split('.');
//     let current = newFields[fieldIndex];
    
//     for (let i = 0; i < keys.length - 1; i++) {
//       if (!current[keys[i]]) current[keys[i]] = {};
//       current = current[keys[i]];
//     }
    
//     current[keys[keys.length - 1]] = value;
    
//     // ✅ FIX: Only auto-generate field ID when label changes AND id is not manually set
//     if (fieldPath === 'label' && (!current.id || current.id.startsWith('field_'))) {
//       current.id = value.toLowerCase()
//         .replace(/[^a-z0-9\s]/g, '')
//         .replace(/\s+/g, '_')
//         .substring(0, 30);
//     }
    
//     // ✅ NEW: Auto-apply validations when smartFieldType changes
//     if (fieldPath === 'smartFieldType') {
//       const validation = SMART_FIELD_TYPES.find(v => v.value === value);
//       if (validation) {
//         current.type = validation.fieldType;
//         current.validation = { ...validation.autoValidations };
//         current.placeholder = validation.placeholder;
//         current.errorMessages = { ...validation.errorMessages };
//         if (validation.formatting) {
//           current.formatting = { ...validation.formatting };
//         }
//         // Add validation reference
//         current._validationRef = {
//           source: "field-validations",
//           key: value,
//           version: "1.0.0"
//         };
//       }
//     }
    
//     onUpdateForm({ ...formConfig, fields: newFields });
//   };

//   const addField = () => {
//     const newField = {
//       id: `field_${Date.now()}`,
//       label: 'New Field',
//       smartFieldType: 'textOnly', // ✅ NEW: Default to textOnly
//       type: 'text',
//       required: false,
//       validation: {},
//       dataSource: { type: 'manual' },
//       visibility: true,
//       defaultValue: '',
//       // ✅ NEW: Advanced options structure
//       advancedOptions: {
//         visibleOnlyWhen: null,
//         captureOnlyWhen: null,
//         makeReadOnlyWhen: null,
//         additionalValidations: []
//       }
//     };
    
//     onUpdateForm({
//       ...formConfig,
//       fields: [...formConfig.fields, newField]
//     });
//   };

//   const removeField = (fieldIndex) => {
//     const newFields = formConfig.fields.filter((_, index) => index !== fieldIndex);
//     onUpdateForm({ ...formConfig, fields: newFields });
//   };

//   const moveField = (fromIndex, toIndex) => {
//     const newFields = [...formConfig.fields];
//     const [movedField] = newFields.splice(fromIndex, 1);
//     newFields.splice(toIndex, 0, movedField);
//     onUpdateForm({ ...formConfig, fields: newFields });
//   };

//   // Action handlers (keep existing code)
//   const addAction = (actionData) => {
//     console.log('Adding action:', actionData);
//     const newActions = [...(formConfig.actions || []), actionData];
//     onUpdateForm({ ...formConfig, actions: newActions });
//     setShowActionSelector(false);
//     setEditingActionIndex(null);
//     setEditingActionType(null);
//     setEditingActionConfig(null);
//   };

//   const removeAction = (index) => {
//     const newActions = formConfig.actions.filter((_, i) => i !== index);
//     onUpdateForm({ ...formConfig, actions: newActions });
//   };

//   const moveAction = (index, direction) => {
//     const newActions = [...formConfig.actions];
//     const newIndex = index + direction;
    
//     if (newIndex >= 0 && newIndex < newActions.length) {
//       [newActions[index], newActions[newIndex]] = [newActions[newIndex], newActions[index]];
//       onUpdateForm({ ...formConfig, actions: newActions });
//     }
//   };

//   const editAction = (index) => {
//     const action = formConfig.actions[index];
//     console.log('Editing action at index', index, ':', action);
    
//     setEditingActionIndex(index);
//     setEditingActionType(action.action);
//     setEditingActionConfig(action);
//     setShowActionSelector(true);
//   };

//   const saveEditedAction = (newConfig) => {
//     console.log('Saving edited action:', newConfig);
//     const newActions = [...formConfig.actions];
//     newActions[editingActionIndex] = {
//       action: editingActionType,
//       ...newConfig
//     };
    
//     onUpdateForm({ ...formConfig, actions: newActions });
    
//     setEditingActionIndex(null);
//     setEditingActionType(null);
//     setEditingActionConfig(null);
//     setShowActionSelector(false);
//   };

//   const cancelEdit = () => {
//     setEditingActionIndex(null);
//     setEditingActionType(null);
//     setEditingActionConfig(null);
//     setShowActionSelector(false);
//   };

//   // ✅ NEW: Open advanced validation popup
//   const openAdvancedPopup = (fieldIndex) => {
//     setActiveFieldIndex(fieldIndex);
//     setShowAdvancedPopup(true);
//   };

//   // ✅ NEW: Helper to get trigger display
//   const getTriggerDisplay = (action) => {
//     const triggerType = action.triggerType || 'button';
    
//     switch (triggerType) {
//       case 'button':
//         return `🔘 Button: "${action.triggerLabel || 'Click Me'}"`;
//       case 'link':
//         return `🔗 Link: "${action.triggerLabel || 'Click here'}"`;
//       case 'icon':
//         return `🎨 Icon: ${action.triggerIcon || '❓'}`;
//       case 'component':
//         return `📦 Component ${action.triggerEvent || 'onClick'}`;
//       default:
//         return '🔘 Button';
//     }
//   };

//   return (
//     <div style={{
//       height: '100%',
//       padding: '24px',
//       backgroundColor: '#FFFFFF',
//       borderRight: '1px solid #E5E7EB',
//       overflow: 'auto'
//     }}>
//       {/* Form Header Configuration - Keep existing code */}
//       <div style={{ marginBottom: '32px' }}>
//         <h3 style={{
//           margin: '0 0 20px',
//           fontSize: '18px',
//           fontWeight: '700',
//           color: '#111827'
//         }}>
//           📋 Form Configuration
//         </h3>

//         <div style={{
//           display: 'grid',
//           gap: '16px',
//           padding: '20px',
//           backgroundColor: '#F9FAFB',
//           borderRadius: '12px',
//           border: '1px solid #E5E7EB',
//           marginBottom: '24px'
//         }}>
//           <div>
//             <label style={{
//               display: 'block',
//               fontSize: '13px',
//               fontWeight: '600',
//               color: '#374151',
//               marginBottom: '6px'
//             }}>
//               Form Title
//             </label>
//             <input
//               type="text"
//               value={formConfig.title}
//               onChange={(e) => updateFormField('title', e.target.value)}
//               style={{
//                 width: '100%',
//                 padding: '10px 12px',
//                 fontSize: '14px',
//                 border: '1px solid #D1D5DB',
//                 borderRadius: '8px',
//                 backgroundColor: '#FFFFFF'
//               }}
//             />
//           </div>

//           <div>
//             <label style={{
//               display: 'block',
//               fontSize: '13px',
//               fontWeight: '600',
//               color: '#374151',
//               marginBottom: '6px'
//             }}>
//               Description
//             </label>
//             <textarea
//               value={formConfig.description}
//               onChange={(e) => updateFormField('description', e.target.value)}
//               rows={2}
//               style={{
//                 width: '100%',
//                 padding: '10px 12px',
//                 fontSize: '14px',
//                 border: '1px solid #D1D5DB',
//                 borderRadius: '8px',
//                 backgroundColor: '#FFFFFF',
//                 resize: 'vertical'
//               }}
//             />
//           </div>

//           <div>
//             <label style={{
//               display: 'block',
//               fontSize: '13px',
//               fontWeight: '600',
//               color: '#374151',
//               marginBottom: '6px'
//             }}>
//               Submit Button Label
//             </label>
//             <input
//               type="text"
//               value={formConfig.submitLabel}
//               onChange={(e) => updateFormField('submitLabel', e.target.value)}
//               style={{
//                 width: '100%',
//                 padding: '10px 12px',
//                 fontSize: '14px',
//                 border: '1px solid #D1D5DB',
//                 borderRadius: '8px',
//                 backgroundColor: '#FFFFFF'
//               }}
//             />
//           </div>
//         </div>
//       </div>

//       {/* Form Actions Section - Keep existing code */}
//       <div style={{ marginBottom: '32px' }}>
//         <div style={{
//           display: 'flex',
//           alignItems: 'center',
//           justifyContent: 'space-between',
//           marginBottom: '16px'
//         }}>
//           <h3 style={{
//             margin: 0,
//             fontSize: '18px',
//             fontWeight: '700',
//             color: '#111827'
//           }}>
//             ⚡ Form Actions
//           </h3>
//           <button 
//             type="button"
//             onClick={() => {
//               setEditingActionIndex(null);
//               setEditingActionType(null);
//               setEditingActionConfig(null);
//               setShowActionSelector(true);
//             }}
//             style={{
//               padding: '8px 16px',
//               fontSize: '13px',
//               fontWeight: '600',
//               color: '#FFFFFF',
//               backgroundColor: '#8B5CF6',
//               border: 'none',
//               borderRadius: '8px',
//               cursor: 'pointer',
//               display: 'flex',
//               alignItems: 'center',
//               gap: '6px'
//             }}
//           >
//             ➕ Add Action
//           </button>
//         </div>

//         {/* Keep existing actions rendering code */}
//         {formConfig.actions && formConfig.actions.length > 0 ? (
//           <div style={{
//             display: 'flex',
//             flexDirection: 'column',
//             gap: '12px',
//             padding: '16px',
//             backgroundColor: '#F9FAFB',
//             borderRadius: '12px',
//             border: '1px solid #E5E7EB'
//           }}>
//             {formConfig.actions.map((action, index) => {
//               const ActionClass = actionRegistry.getAction(action.action);
//               const actionName = ActionClass ? ActionClass.actionName : action.action;
//               const actionIcon = ActionClass ? ActionClass.actionIcon : '⚡';
//               const actionInstance = ActionClass ? new ActionClass(action) : null;
//               const actionSummary = actionInstance?.getSummary ? actionInstance.getSummary() : 'Unknown action';

//               return (
//                 <div 
//                   key={index} 
//                   style={{
//                     display: 'flex',
//                     flexDirection: 'column',
//                     gap: '8px',
//                     padding: '16px',
//                     backgroundColor: '#FFFFFF',
//                     borderRadius: '8px',
//                     border: '1px solid #E5E7EB',
//                     boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)'
//                   }}
//                 >
//                   <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
//                     <div style={{
//                       display: 'flex',
//                       alignItems: 'center',
//                       justifyContent: 'center',
//                       width: '32px',
//                       height: '32px',
//                       backgroundColor: '#F3F4F6',
//                       borderRadius: '6px',
//                       fontSize: '12px',
//                       fontWeight: '600',
//                       color: '#6B7280'
//                     }}>
//                       {index + 1}
//                     </div>
//                     <div style={{ fontSize: '20px' }}>{actionIcon}</div>
//                     <div style={{ flex: 1 }}>
//                       <div style={{
//                         fontSize: '14px',
//                         fontWeight: '600',
//                         color: '#111827',
//                         marginBottom: '2px'
//                       }}>
//                         {actionName}
//                       </div>
//                       <div style={{ fontSize: '12px', color: '#6B7280' }}>
//                         {actionSummary}
//                       </div>
//                     </div>
//                     <div style={{ display: 'flex', gap: '4px' }}>
//                       <button 
//                         type="button"
//                         onClick={() => moveAction(index, -1)}
//                         disabled={index === 0}
//                         style={{
//                           padding: '6px 10px',
//                           fontSize: '14px',
//                           backgroundColor: 'transparent',
//                           border: '1px solid #D1D5DB',
//                           borderRadius: '6px',
//                           cursor: index === 0 ? 'not-allowed' : 'pointer',
//                           color: index === 0 ? '#D1D5DB' : '#6B7280'
//                         }}
//                         title="Move Up"
//                       >
//                         ↑
//                       </button>
//                       <button 
//                         type="button"
//                         onClick={() => moveAction(index, 1)}
//                         disabled={index === formConfig.actions.length - 1}
//                         style={{
//                           padding: '6px 10px',
//                           fontSize: '14px',
//                           backgroundColor: 'transparent',
//                           border: '1px solid #D1D5DB',
//                           borderRadius: '6px',
//                           cursor: index === formConfig.actions.length - 1 ? 'not-allowed' : 'pointer',
//                           color: index === formConfig.actions.length - 1 ? '#D1D5DB' : '#6B7280'
//                         }}
//                         title="Move Down"
//                       >
//                         ↓
//                       </button>
//                       <button 
//                         type="button"
//                         onClick={() => editAction(index)}
//                         style={{
//                           padding: '6px 10px',
//                           fontSize: '14px',
//                           backgroundColor: 'transparent',
//                           border: '1px solid #D1D5DB',
//                           borderRadius: '6px',
//                           cursor: 'pointer',
//                           color: '#6B7280'
//                         }}
//                         title="Edit"
//                       >
//                         ✏️
//                       </button>
//                       <button 
//                         type="button"
//                         onClick={() => removeAction(index)}
//                         style={{
//                           padding: '6px 10px',
//                           fontSize: '14px',
//                           backgroundColor: 'transparent',
//                           border: '1px solid #FCA5A5',
//                           borderRadius: '6px',
//                           cursor: 'pointer',
//                           color: '#DC2626'
//                         }}
//                         title="Delete"
//                       >
//                         🗑️
//                       </button>
//                     </div>
//                   </div>

//                   <div style={{
//                     display: 'flex',
//                     alignItems: 'center',
//                     gap: '8px',
//                     paddingLeft: '44px',
//                     fontSize: '12px',
//                     color: '#6B7280'
//                   }}>
//                     <span style={{ fontWeight: '600' }}>Trigger:</span>
//                     <span style={{
//                       padding: '4px 10px',
//                       backgroundColor: '#EDE9FE',
//                       color: '#7C3AED',
//                       borderRadius: '6px',
//                       fontSize: '11px',
//                       fontWeight: '600'
//                     }}>
//                       {getTriggerDisplay(action)}
//                     </span>
//                   </div>
//                 </div>
//               );
//             })}
//           </div>
//         ) : (
//           <div style={{
//             padding: '32px',
//             textAlign: 'center',
//             backgroundColor: '#F9FAFB',
//             borderRadius: '12px',
//             border: '1px solid #E5E7EB'
//           }}>
//           <div style={{ fontSize: '48px', marginBottom: '12px' }}>⚡</div>
//             <p style={{
//               margin: '0 0 8px',
//               fontSize: '14px',
//               fontWeight: '600',
//               color: '#111827'
//             }}>
//               No actions configured
//             </p>
//             <p style={{ margin: 0, fontSize: '13px', color: '#6B7280' }}>
//               Actions define what happens when the form is submitted (e.g., Save to Table, Validate, Send Email)
//             </p>
//           </div>
//         )}
//       </div>

//       {/* ✅ UPDATED: Fields Configuration with Smart Field Types */}
//       <div>
//         <div style={{
//           display: 'flex',
//           alignItems: 'center',
//           justifyContent: 'space-between',
//           marginBottom: '16px'
//         }}>
//           <h4 style={{
//             margin: 0,
//             fontSize: '16px',
//             fontWeight: '700',
//             color: '#111827'
//           }}>
//             Form Fields ({formConfig.fields.length})
//           </h4>
//           <button
//             onClick={addField}
//             style={{
//               padding: '8px 16px',
//               fontSize: '13px',
//               fontWeight: '600',
//               color: '#FFFFFF',
//               backgroundColor: '#10B981',
//               border: 'none',
//               borderRadius: '8px',
//               cursor: 'pointer',
//               display: 'flex',
//               alignItems: 'center',
//               gap: '6px'
//             }}
//           >
//             ➕ Add Field
//           </button>
//         </div>

//         {/* ✅ UPDATED: Fields Grid with Smart Validation */}
//         <div style={{
//           border: '1px solid #E5E7EB',
//           borderRadius: '12px',
//           backgroundColor: '#FFFFFF',
//           overflow: 'hidden'
//         }}>
//           {/* Grid Header */}
//           <div style={{
//             display: 'grid',
//             gridTemplateColumns: '2fr 1.5fr 1.5fr 80px 100px 80px 40px',
//             gap: '12px',
//             padding: '12px 16px',
//             backgroundColor: '#F9FAFB',
//             borderBottom: '1px solid #E5E7EB',
//             fontSize: '12px',
//             fontWeight: '600',
//             color: '#6B7280'
//           }}>
//             <div>FIELD LABEL</div>
//             <div>FIELD ID</div>
//             <div>FIELD TYPE</div>
//             <div>REQUIRED</div>
//             <div>ADVANCED</div>
//             <div>ORDER</div>
//             <div></div>
//           </div>

//           {/* Field Rows */}
//           {formConfig.fields.map((field, index) => {
//             const selectedValidation = SMART_FIELD_TYPES.find(v => v.value === field.smartFieldType);
            
//             return (
//               <div
//                 key={`field-${field.id}-${index}`}
//                 style={{
//                   display: 'grid',
//                   gridTemplateColumns: '2fr 1.5fr 1.5fr 80px 100px 80px 40px',
//                   gap: '12px',
//                   padding: '16px',
//                   borderBottom: index < formConfig.fields.length - 1 ? '1px solid #F3F4F6' : 'none',
//                   alignItems: 'center'
//                 }}
//               >
//                 {/* ✅ FIX: Field Label - Add key to prevent focus loss */}
//                 <input
//                   key={`label-${field.id}`}
//                   type="text"
//                   value={field.label}
//                   onChange={(e) => updateField(index, 'label', e.target.value)}
//                   style={{
//                     padding: '8px 10px',
//                     fontSize: '13px',
//                     border: '1px solid #D1D5DB',
//                     borderRadius: '6px',
//                     width: '100%'
//                   }}
//                 />

//                 {/* Field ID (readonly) */}
//                 <input
//                   type="text"
//                   value={field.id}
//                   readOnly
//                   style={{
//                     padding: '8px 10px',
//                     fontSize: '13px',
//                     border: '1px solid #E5E7EB',
//                     borderRadius: '6px',
//                     backgroundColor: '#F9FAFB',
//                     color: '#6B7280',
//                     width: '100%'
//                   }}
//                 />

//                 {/* ✅ FIX: Smart Field Type Dropdown with WORKING Tooltip */}
//                 <div 
//                   style={{ position: 'relative' }}
//                   onMouseEnter={() => setTooltipVisible({ ...tooltipVisible, [index]: true })}
//                   onMouseLeave={() => setTooltipVisible({ ...tooltipVisible, [index]: false })}
//                 >
//                   <select
//                     value={field.smartFieldType || field.type}
//                     onChange={(e) => updateField(index, 'smartFieldType', e.target.value)}
//                     style={{
//                       padding: '8px 10px',
//                       fontSize: '13px',
//                       border: '1px solid #D1D5DB',
//                       borderRadius: '6px',
//                       width: '100%',
//                       cursor: 'pointer'
//                     }}
//                   >
//                     {SMART_FIELD_TYPES.map(validation => (
//                       <option key={validation.value} value={validation.value}>
//                         {validation.label}
//                       </option>
//                     ))}
//                   </select>
                  
//                   {/* ✅ FIX: Working Tooltip */}
//                   {tooltipVisible[index] && selectedValidation?.tooltip && (
//                     <div style={{
//                       position: 'absolute',
//                       top: '100%',
//                       left: '0',
//                       marginTop: '4px',
//                       padding: '8px 12px',
//                       backgroundColor: '#1F2937',
//                       color: '#FFFFFF',
//                       fontSize: '12px',
//                       borderRadius: '6px',
//                       boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
//                       zIndex: 1000,
//                       maxWidth: '250px',
//                       whiteSpace: 'normal',
//                       lineHeight: '1.4'
//                     }}>
//                       {selectedValidation.tooltip}
//                       {/* Tooltip arrow */}
//                       <div style={{
//                         position: 'absolute',
//                         top: '-4px',
//                         left: '12px',
//                         width: '8px',
//                         height: '8px',
//                         backgroundColor: '#1F2937',
//                         transform: 'rotate(45deg)'
//                       }} />
//                     </div>
//                   )}
//                 </div>

//                 {/* Required Toggle */}
//                 <label style={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'center',
//                   cursor: 'pointer'
//                 }}>
//                   <input
//                     type="checkbox"
//                     checked={field.required}
//                     onChange={(e) => updateField(index, 'required', e.target.checked)}
//                     style={{
//                       width: '16px',
//                       height: '16px',
//                       accentColor: '#3B82F6'
//                     }}
//                   />
//                 </label>

//                 {/* ✅ NEW: More Link for Advanced Options */}
//                 <button
//                   type="button"
//                   onClick={() => openAdvancedPopup(index)}
//                   style={{
//                     padding: '6px 12px',
//                     fontSize: '12px',
//                     fontWeight: '600',
//                     color: '#3B82F6',
//                     backgroundColor: '#EFF6FF',
//                     border: '1px solid #BFDBFE',
//                     borderRadius: '6px',
//                     cursor: 'pointer',
//                     transition: 'all 0.2s'
//                   }}
//                   onMouseOver={(e) => {
//                     e.target.style.backgroundColor = '#DBEAFE';
//                     e.target.style.borderColor = '#93C5FD';
//                   }}
//                   onMouseOut={(e) => {
//                     e.target.style.backgroundColor = '#EFF6FF';
//                     e.target.style.borderColor = '#BFDBFE';
//                   }}
//                   title="Configure advanced validations"
//                 >
//                   More →
//                 </button>

//                 {/* Move Controls */}
//                 <div style={{
//                   display: 'flex',
//                   flexDirection: 'column',
//                   gap: '2px',
//                   alignItems: 'center'
//                 }}>
//                   <button
//                     onClick={() => index > 0 && moveField(index, index - 1)}
//                     disabled={index === 0}
//                     style={{
//                       padding: '2px 4px',
//                       fontSize: '10px',
//                       border: 'none',
//                       backgroundColor: 'transparent',
//                       cursor: index === 0 ? 'not-allowed' : 'pointer',
//                       color: index === 0 ? '#D1D5DB' : '#6B7280'
//                     }}
//                   >
//                     ▲
//                   </button>
//                   <button
//                     onClick={() => index < formConfig.fields.length - 1 && moveField(index, index + 1)}
//                     disabled={index === formConfig.fields.length - 1}
//                     style={{
//                       padding: '2px 4px',
//                       fontSize: '10px',
//                       border: 'none',
//                       backgroundColor: 'transparent',
//                       cursor: index === formConfig.fields.length - 1 ? 'not-allowed' : 'pointer',
//                       color: index === formConfig.fields.length - 1 ? '#D1D5DB' : '#6B7280'
//                     }}
//                   >
//                     ▼
//                   </button>
//                 </div>

//                 {/* Remove Button */}
//                 <button
//                   onClick={() => removeField(index)}
//                   style={{
//                     padding: '4px',
//                     fontSize: '12px',
//                     backgroundColor: 'transparent',
//                     border: '1px solid #FCA5A5',
//                     borderRadius: '4px',
//                     cursor: 'pointer',
//                     color: '#DC2626'
//                   }}
//                   title="Remove Field"
//                 >
//                   🗑️
//                 </button>
//               </div>
//             );
//           })}

//           {formConfig.fields.length === 0 && (
//             <div style={{
//               padding: '32px',
//               textAlign: 'center',
//               color: '#9CA3AF',
//               fontSize: '14px'
//             }}>
//               No fields added yet. Click "Add Field" to get started.
//             </div>
//           )}
//         </div>
//       </div>

//       {/* ✅ NEW: Advanced Validation Popup */}
//       {showAdvancedPopup && activeFieldIndex !== null && (
//         <div style={{
//           position: 'fixed',
//           top: 0,
//           left: 0,
//           right: 0,
//           bottom: 0,
//           backgroundColor: 'rgba(0, 0, 0, 0.5)',
//           display: 'flex',
//           alignItems: 'center',
//           justifyContent: 'center',
//           zIndex: 10000
//         }}>
//           <div style={{
//             backgroundColor: '#FFFFFF',
//             borderRadius: '12px',
//             padding: '24px',
//             maxWidth: '600px',
//             width: '90%',
//             maxHeight: '80vh',
//             overflow: 'auto',
//             boxShadow: '0 25px 50px rgba(0, 0, 0, 0.25)'
//           }}>
//             <div style={{
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'space-between',
//               marginBottom: '20px'
//             }}>
//               <h3 style={{
//                 margin: 0,
//                 fontSize: '18px',
//                 fontWeight: '700',
//                 color: '#111827'
//               }}>
//                 Advanced Options - {formConfig.fields[activeFieldIndex]?.label}
//               </h3>
//               <button
//                 onClick={() => setShowAdvancedPopup(false)}
//                 style={{
//                   padding: '4px 8px',
//                   fontSize: '18px',
//                   backgroundColor: 'transparent',
//                   border: 'none',
//                   cursor: 'pointer',
//                   color: '#6B7280'
//                 }}
//               >
//                 ✕
//               </button>
//             </div>

//             {/* Visibility Conditions */}
//             <div style={{ marginBottom: '20px' }}>
//               <label style={{
//                 display: 'block',
//                 fontSize: '13px',
//                 fontWeight: '600',
//                 color: '#374151',
//                 marginBottom: '6px'
//               }}>
//                 Visible only when
//               </label>
//               <select
//                 value={formConfig.fields[activeFieldIndex]?.advancedOptions?.visibleOnlyWhen || ''}
//                 onChange={(e) => updateField(activeFieldIndex, 'advancedOptions.visibleOnlyWhen', e.target.value || null)}
//                 style={{
//                   width: '100%',
//                   padding: '8px 10px',
//                   fontSize: '13px',
//                   border: '1px solid #D1D5DB',
//                   borderRadius: '6px'
//                 }}
//               >
//                 <option value="">Always Visible</option>
//                 {COMPONENT_VALIDATIONS.visibilityConditions.map(condition => (
//                   <option key={condition.value} value={condition.value}>
//                     {condition.label}
//                   </option>
//                 ))}
//               </select>
//               <p style={{
//                 margin: '4px 0 0',
//                 fontSize: '12px',
//                 color: '#6B7280'
//               }}>
//                 Control when this field appears to users
//               </p>
//             </div>

//             {/* Capture Conditions */}
//             <div style={{ marginBottom: '20px' }}>
//               <label style={{
//                 display: 'block',
//                 fontSize: '13px',
//                 fontWeight: '600',
//                 color: '#374151',
//                 marginBottom: '6px'
//               }}>
//                 Capture only when
//                 {formConfig.fields[activeFieldIndex]?.required && (
//                   <span style={{
//                     marginLeft: '8px',
//                     fontSize: '11px',
//                     fontWeight: '500',
//                     color: '#DC2626',
//                     backgroundColor: '#FEE2E2',
//                     padding: '2px 6px',
//                     borderRadius: '4px'
//                   }}>
//                     ⚠️ Conflicts with Required
//                   </span>
//                 )}
//               </label>
//               <select
//                 value={formConfig.fields[activeFieldIndex]?.advancedOptions?.captureOnlyWhen || ''}
//                 onChange={(e) => updateField(activeFieldIndex, 'advancedOptions.captureOnlyWhen', e.target.value || null)}
//                 style={{
//                   width: '100%',
//                   padding: '8px 10px',
//                   fontSize: '13px',
//                   border: '1px solid #D1D5DB',
//                   borderRadius: '6px'
//                 }}
//               >
//                 <option value="">Always Capture</option>
//                 {COMPONENT_VALIDATIONS.captureConditions.map(condition => (
//                   <option key={condition.value} value={condition.value}>
//                     {condition.label}
//                   </option>
//                 ))}
//               </select>
//               <p style={{
//                 margin: '4px 0 0',
//                 fontSize: '12px',
//                 color: '#6B7280'
//               }}>
//                 Conditionally make field required
//               </p>
//             </div>

//             {/* Read-Only Conditions */}
//             <div style={{ marginBottom: '20px' }}>
//               <label style={{
//                 display: 'block',
//                 fontSize: '13px',
//                 fontWeight: '600',
//                 color: '#374151',
//                 marginBottom: '6px'
//               }}>
//                 Make Read Only when
//               </label>
//               <select
//                 value={formConfig.fields[activeFieldIndex]?.advancedOptions?.makeReadOnlyWhen || ''}
//                 onChange={(e) => updateField(activeFieldIndex, 'advancedOptions.makeReadOnlyWhen', e.target.value || null)}
//                 style={{
//                   width: '100%',
//                   padding: '8px 10px',
//                   fontSize: '13px',
//                   border: '1px solid #D1D5DB',
//                   borderRadius: '6px'
//                 }}
//               >
//                 <option value="">Always Editable</option>
//                 {COMPONENT_VALIDATIONS.readOnlyConditions.map(condition => (
//                   <option key={condition.value} value={condition.value}>
//                     {condition.label}
//                   </option>
//                 ))}
//               </select>
//               <p style={{
//                 margin: '4px 0 0',
//                 fontSize: '12px',
//                 color: '#6B7280'
//               }}>
//                 Lock field based on conditions
//               </p>
//             </div>

//             {/* ✅ NEW: Add Business Validation Link */}
//             <div style={{
//               padding: '16px',
//               backgroundColor: '#F9FAFB',
//               borderRadius: '8px',
//               border: '1px dashed #D1D5DB',
//               textAlign: 'center',
//               marginBottom: '20px'
//             }}>
//               <p style={{
//                 margin: '0 0 12px',
//                 fontSize: '13px',
//                 color: '#6B7280'
//               }}>
//                 Need custom business validation?
//               </p>
//               <button
//                 type="button"
//                 onClick={() => {
//                   // ✅ Save form as draft first
//                   alert('⚠️ Form will be saved as draft before creating new validation');
//                   // TODO: Implement save as draft + navigate to validation creator
//                   console.log('Save form as draft, then open validation creator');
//                 }}
//                 style={{
//                   padding: '8px 16px',
//                   fontSize: '13px',
//                   fontWeight: '600',
//                   color: '#059669',
//                   backgroundColor: '#ECFDF5',
//                   border: '1px solid #A7F3D0',
//                   borderRadius: '6px',
//                   cursor: 'pointer',
//                   transition: 'all 0.2s'
//                 }}
//                 onMouseOver={(e) => {
//                   e.target.style.backgroundColor = '#D1FAE5';
//                   e.target.style.borderColor = '#6EE7B7';
//                 }}
//                 onMouseOut={(e) => {
//                   e.target.style.backgroundColor = '#ECFDF5';
//                   e.target.style.borderColor = '#A7F3D0';
//                 }}
//               >
//                 + Add New Business Validation
//               </button>
//             </div>

//             {/* Popup Actions */}
//             <div style={{
//               display: 'flex',
//               gap: '12px',
//               justifyContent: 'flex-end'
//             }}>
//               <button
//                 onClick={() => setShowAdvancedPopup(false)}
//                 style={{
//                   padding: '10px 20px',
//                   fontSize: '14px',
//                   fontWeight: '600',
//                   color: '#6B7280',
//                   backgroundColor: '#F9FAFB',
//                   border: '1px solid #E5E7EB',
//                   borderRadius: '8px',
//                   cursor: 'pointer'
//                 }}
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={() => setShowAdvancedPopup(false)}
//                 style={{
//                   padding: '10px 20px',
//                   fontSize: '14px',
//                   fontWeight: '600',
//                   color: '#FFFFFF',
//                   backgroundColor: '#3B82F6',
//                   border: 'none',
//                   borderRadius: '8px',
//                   cursor: 'pointer'
//                 }}
//               >
//                 Apply
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Action Selector Modal */}
//       {showActionSelector && (
//         <ActionSelector
//           onActionAdd={editingActionIndex !== null ? saveEditedAction : addAction}
//           onClose={editingActionIndex !== null ? cancelEdit : () => setShowActionSelector(false)}
//           existingActions={formConfig.actions || []}
//           editMode={editingActionIndex !== null}
//           editActionType={editingActionType}
//           editActionConfig={editingActionConfig}
//         />
//       )}
//     </div>
//   );
// };

// export default FormConfigPanel;

// Updated by Claude for custom business validation integration on 2025-11-09 22:01:00
// Added: ValidationConfigForm modal, custom validation loading, dropdown integration

// Fixed by Claude on 2025-11-09 22:45:00 - Removed COMPONENT_VALIDATIONS import
// Using only user-configured custom validations in Advanced Options dropdowns
// Fixed by Claude on 2025-11-09 22:50:00 - Added useNavigate for proper routing

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { SMART_FIELD_TYPES } from '../../config/field-validations';
// import ActionSelector from '../ActionSystem/ActionSelector'; // REMOVED: Old ActionSystem (2025-11-20)
// import actionRegistry from '../ActionSystem/ActionRegistry'; // REMOVED: Old ActionSystem (2025-11-20)
import ValidationConfigForm from '../Validations/ValidationConfigForm';
import validationService from '../../services/validationService'; // Added by Claude on 2025-11-10 for database validation loading
import { createLogger } from '../../utils/logger';
// import '../ActionSystem/actions.css'; // REMOVED: Old ActionSystem (2025-11-20)
// Added by Claude on 2025-11-23 - Field-level validation components
import FieldValidationBuilder from './FieldValidationBuilder';
import FieldValidationList from './FieldValidationList';

const logger = createLogger("src/components/FormBuilder/FormConfigPanel.jsx");

const FormConfigPanel = ({ formConfig, onUpdateForm, appName }) => {
  const navigate = useNavigate(); // Fixed by Claude on 2025-11-09 22:50:00
  
  const [showActionSelector, setShowActionSelector] = useState(false);
  const [editingActionIndex, setEditingActionIndex] = useState(null);
  const [editingActionType, setEditingActionType] = useState(null);
  const [editingActionConfig, setEditingActionConfig] = useState(null);
  const [showAdvancedPopup, setShowAdvancedPopup] = useState(false);
  const [activeFieldIndex, setActiveFieldIndex] = useState(null);
  const [tooltipVisible, setTooltipVisible] = useState({});
  
  // Added by Claude on 2025-11-09 22:01:00 - Custom validation management
  const [showValidationForm, setShowValidationForm] = useState(false);
  const [customValidations, setCustomValidations] = useState([]);
  
  // Added by Claude on 2025-11-23 - Field-level validation management
  const [showFieldValidationBuilder, setShowFieldValidationBuilder] = useState(false);
  const [editingFieldValidation, setEditingFieldValidation] = useState(null);
  
  // Updated by Claude on 2025-11-10 - Load custom validations from database instead of localStorage
  // Fixed by Claude on 2025-11-10 - Use appName prop from parent component
  useEffect(() => {
    const loadValidations = async () => {
      if (!appName) {
        logger.warn("useEffect", "No appName provided, skipping validation load");
        return;
      }

      logger.entry("useEffect", "Loading custom validations from database", { appName });
      
      try {
        const data = await validationService.getAllValidations(appName);
        setCustomValidations(data);
        logger.info("useEffect", "Custom validations loaded from database", { count: data.length, appName });
      } catch (error) {
        logger.error("useEffect", "Failed to load custom validations from database", error);
        setCustomValidations([]); // Set empty array on error
      }
    };

    loadValidations();
  }, [appName]);
  // End of custom validation loading
  
  const updateFormField = (path, value) => {
    const newConfig = { ...formConfig };
    const keys = path.split('.');
    let current = newConfig;
    
    for (let i = 0; i < keys.length - 1; i++) {
      if (!current[keys[i]]) current[keys[i]] = {};
      current = current[keys[i]];
    }
    
    current[keys[keys.length - 1]] = value;
    onUpdateForm(newConfig);
  };

  const updateField = (fieldIndex, fieldPath, value) => {
    const newFields = [...formConfig.fields];
    const keys = fieldPath.split('.');
    let current = newFields[fieldIndex];
    
    for (let i = 0; i < keys.length - 1; i++) {
      if (!current[keys[i]]) current[keys[i]] = {};
      current = current[keys[i]];
    }
    
    current[keys[keys.length - 1]] = value;
    
    if (fieldPath === 'label' && !current._idManuallySet) {
      current.id = value.toLowerCase()
        .replace(/[^a-z0-9\s]/g, '')
        .replace(/\s+/g, '_')
        .substring(0, 30) || `field_${Date.now()}`;
    }
    
    if (fieldPath === 'smartFieldType') {
      const validation = SMART_FIELD_TYPES.find(v => v.value === value);
      if (validation) {
        current.type = validation.fieldType;
        current.validation = { ...validation.autoValidations };
        current.placeholder = validation.placeholder;
        current.errorMessages = { ...validation.errorMessages };
        if (validation.formatting) {
          current.formatting = { ...validation.formatting };
        }
        if (validation.rows) {
          current.rows = validation.rows;
        }
        current._validationRef = {
          source: "field-validations",
          key: value,
          version: "1.0.0"
        };
      }
    }
    
    onUpdateForm({ ...formConfig, fields: newFields });
  };

  const addField = () => {
    const defaultValidation = SMART_FIELD_TYPES[0];
    const newField = {
      id: `field_${Date.now()}`,
      label: 'New Field',
      smartFieldType: defaultValidation.value,
      type: defaultValidation.fieldType,
      required: false,
      validation: { ...defaultValidation.autoValidations },
      errorMessages: { ...defaultValidation.errorMessages },
      placeholder: defaultValidation.placeholder,
      dataSource: { type: 'manual' },
      visibility: true,
      defaultValue: '',
      advancedOptions: {
        visibleOnlyWhen: null,
        captureOnlyWhen: null,
        makeReadOnlyWhen: null,
        additionalValidations: []
      },
      _validationRef: {
        source: "field-validations",
        key: defaultValidation.value,
        version: "1.0.0"
      }
    };
    
    onUpdateForm({
      ...formConfig,
      fields: [...formConfig.fields, newField]
    });
  };

  const removeField = (fieldIndex) => {
    const newFields = formConfig.fields.filter((_, index) => index !== fieldIndex);
    onUpdateForm({ ...formConfig, fields: newFields });
  };

  const moveField = (fromIndex, toIndex) => {
    const newFields = [...formConfig.fields];
    const [movedField] = newFields.splice(fromIndex, 1);
    newFields.splice(toIndex, 0, movedField);
    onUpdateForm({ ...formConfig, fields: newFields });
  };

  const addAction = (actionData) => {
    const newActions = [...(formConfig.actions || []), actionData];
    onUpdateForm({ ...formConfig, actions: newActions });
    setShowActionSelector(false);
    setEditingActionIndex(null);
    setEditingActionType(null);
    setEditingActionConfig(null);
  };

  const removeAction = (index) => {
    const newActions = formConfig.actions.filter((_, i) => i !== index);
    onUpdateForm({ ...formConfig, actions: newActions });
  };

  const moveAction = (index, direction) => {
    const newActions = [...formConfig.actions];
    const newIndex = index + direction;
    
    if (newIndex >= 0 && newIndex < newActions.length) {
      [newActions[index], newActions[newIndex]] = [newActions[newIndex], newActions[index]];
      onUpdateForm({ ...formConfig, actions: newActions });
    }
  };

  const editAction = (index) => {
    const action = formConfig.actions[index];
    setEditingActionIndex(index);
    setEditingActionType(action.action);
    setEditingActionConfig(action);
    setShowActionSelector(true);
  };

  const saveEditedAction = (newConfig) => {
    const newActions = [...formConfig.actions];
    newActions[editingActionIndex] = {
      action: editingActionType,
      ...newConfig
    };
    
    onUpdateForm({ ...formConfig, actions: newActions });
    
    setEditingActionIndex(null);
    setEditingActionType(null);
    setEditingActionConfig(null);
    setShowActionSelector(false);
  };

  const cancelEdit = () => {
    setEditingActionIndex(null);
    setEditingActionType(null);
    setEditingActionConfig(null);
    setShowActionSelector(false);
  };

  const openAdvancedPopup = (fieldIndex) => {
    setActiveFieldIndex(fieldIndex);
    setShowAdvancedPopup(true);
  };
  
  // Fixed by Claude on 2025-11-10 - Unified validation dropdown renderer for all three advanced options
  // All dropdowns now show the same custom validations (no type filtering) for consistency
  // Fixed by Claude on 2025-11-12 - Handle stored value as complete JSON object instead of just ID
  const renderValidationDropdown = (fieldKey, label, validationType, showWarning = false) => {
    const storedValue = formConfig.fields[activeFieldIndex]?.advancedOptions?.[fieldKey];
    // Extract ID from stored value (could be string ID or complete validation JSON object)
    const currentValue = typeof storedValue === 'object' && storedValue?.id ? storedValue.id : (storedValue || '');
    // Show ALL custom validations in all three dropdowns (removed type filtering)
    const allValidations = customValidations || [];

    return (
      <div style={{ marginBottom: '16px' }}>
        <label style={{
          display: 'block',
          fontSize: '13px',
          fontWeight: '600',
          color: '#374151',
          marginBottom: '6px'
        }}>
          {label}
          {showWarning && formConfig.fields[activeFieldIndex]?.required && (
            <span style={{
              marginLeft: '8px',
              fontSize: '10px',
              fontWeight: '500',
              color: '#DC2626',
              backgroundColor: '#FEE2E2',
              padding: '2px 6px',
              borderRadius: '4px'
            }}>
              ⚠️ Conflicts with Required
            </span>
          )}
        </label>
        <select
          value={currentValue}
          onChange={(e) => {
            const selectedValue = e.target.value;
            // Apply custom validation with complete JSON when a custom validation is selected
            if (selectedValue && selectedValue !== '' && selectedValue !== 'never') {
              applyCustomValidation(activeFieldIndex, selectedValue, fieldKey);
            } else {
              // For "Always" or "Never", store the string value directly
              updateField(activeFieldIndex, `advancedOptions.${fieldKey}`, selectedValue || null);
            }
          }}
          style={{
            width: '100%',
            padding: '8px 10px',
            fontSize: '13px',
            border: '1px solid #D1D5DB',
            borderRadius: '6px'
          }}
        >
          <option value="">Always</option>
          <option value="never">Never</option>
          {allValidations.length > 0 && (
            <optgroup label="─── Custom Conditions ───">
              {allValidations.map(validation => (
                <option key={validation.id} value={validation.id}>
                  {validation.name}
                </option>
              ))}
            </optgroup>
          )}
        </select>
      </div>
    );
  };
  // End of fix by Claude on 2025-11-12 - Dropdown now handles complete validation JSON objects

  // Added by Claude on 2025-11-09 22:01:00 - Custom validation handlers
  const handleOpenValidationForm = () => {
    logger.info("handleOpenValidationForm", "Opening validation form modal");
    setShowValidationForm(true);
  };
  
  // Updated by Claude on 2025-11-10 - Save validation to database via API
  // Fixed by Claude on 2025-11-10 - Use appName prop from parent component
  // Fixed by Claude on 2025-11-10 - Normalize appName to match backend collection naming
  const handleSaveCustomValidation = async (validationData) => {
    logger.entry("handleSaveCustomValidation", "Saving custom validation", { validationId: validationData.id, appName });
    
    if (!appName) {
      alert("❌ App name is required to save validation");
      return;
    }
    
    try {
      // Normalize app name to match backend (e.g., "Rama2" -> "rama2")
      const appPrefix = appName.trim().toLowerCase().replace(/[^a-z0-9]+/g, "");
      
      // Save validation to database via API
      const savedValidation = await validationService.createValidation(appName, validationData);
      
      // Reload all validations from database
      const updatedValidations = await validationService.getAllValidations(appName);
      setCustomValidations(updatedValidations);
      
      // Close modal
      setShowValidationForm(false);
      
      logger.info("handleSaveCustomValidation", "Validation saved to database successfully", { 
        validationId: savedValidation.id, 
        appName,
        appPrefix,
        collection: `${appPrefix}_validations`
      });
      alert(`✅ Custom validation created successfully in database!\n\nApp: ${appName}\nCollection: ${appPrefix}_validations\n\nIt's now available in the dropdown.`);
    } catch (error) {
      logger.error("handleSaveCustomValidation", "Failed to save validation to database", error);
      alert(`❌ Failed to save validation: ${error.message}`);
    }
  };
  
  const handleCancelValidationForm = () => {
    logger.info("handleCancelValidationForm", "Canceling validation form");
    setShowValidationForm(false);
  };
  
  // Added by Claude on 2025-11-23 - Field-level validation handlers
  const handleAddFieldValidation = () => {
    logger.info("handleAddFieldValidation", "Opening field validation builder");
    setEditingFieldValidation(null);
    setShowFieldValidationBuilder(true);
  };
  
  const handleEditFieldValidation = (rule) => {
    logger.info("handleEditFieldValidation", "Editing field validation", { ruleId: rule.id });
    setEditingFieldValidation(rule);
    setShowFieldValidationBuilder(true);
  };
  
  const handleSaveFieldValidation = (validationRule) => {
    if (activeFieldIndex === null) return;
    
    logger.info("handleSaveFieldValidation", "Saving field validation", { 
      fieldIndex: activeFieldIndex,
      ruleId: validationRule.id 
    });
    
    const newFields = [...formConfig.fields];
    const field = newFields[activeFieldIndex];
    
    // Initialize fieldValidationRules if not exists
    if (!field.fieldValidationRules) {
      field.fieldValidationRules = [];
    }
    
    // Check if editing existing rule
    const existingIndex = field.fieldValidationRules.findIndex(r => r.id === validationRule.id);
    
    if (existingIndex !== -1) {
      // Update existing rule
      field.fieldValidationRules[existingIndex] = validationRule;
      logger.info("handleSaveFieldValidation", "Updated existing field validation rule");
    } else {
      // Add new rule
      field.fieldValidationRules.push(validationRule);
      logger.info("handleSaveFieldValidation", "Added new field validation rule");
    }
    
    onUpdateForm({ ...formConfig, fields: newFields });
    setShowFieldValidationBuilder(false);
    setEditingFieldValidation(null);
    
    alert(`✅ Field validation "${validationRule.name}" ${existingIndex !== -1 ? 'updated' : 'added'} successfully!`);
  };
  
  const handleDeleteFieldValidation = (rule) => {
    if (activeFieldIndex === null) return;
    
    logger.info("handleDeleteFieldValidation", "Deleting field validation", { 
      fieldIndex: activeFieldIndex,
      ruleId: rule.id 
    });
    
    const newFields = [...formConfig.fields];
    const field = newFields[activeFieldIndex];
    
    if (field.fieldValidationRules) {
      field.fieldValidationRules = field.fieldValidationRules.filter(r => r.id !== rule.id);
      onUpdateForm({ ...formConfig, fields: newFields });
      logger.info("handleDeleteFieldValidation", "Field validation rule deleted");
    }
  };
  
  const handleToggleFieldValidationStatus = (rule) => {
    if (activeFieldIndex === null) return;
    
    const newFields = [...formConfig.fields];
    const field = newFields[activeFieldIndex];
    
    if (field.fieldValidationRules) {
      const ruleIndex = field.fieldValidationRules.findIndex(r => r.id === rule.id);
      if (ruleIndex !== -1) {
        field.fieldValidationRules[ruleIndex].status = 
          field.fieldValidationRules[ruleIndex].status === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE';
        onUpdateForm({ ...formConfig, fields: newFields });
        logger.info("handleToggleFieldValidationStatus", "Toggled field validation status", {
          ruleId: rule.id,
          newStatus: field.fieldValidationRules[ruleIndex].status
        });
      }
    }
  };
  
  const handleCancelFieldValidationBuilder = () => {
    logger.info("handleCancelFieldValidationBuilder", "Canceling field validation builder");
    setShowFieldValidationBuilder(false);
    setEditingFieldValidation(null);
  };
  
  // Fixed by Claude on 2025-11-10 - Updated to store validation reference for each specific advanced option
  // Fixed by Claude on 2025-11-12 - Store complete validation JSON instead of just ID for offline rendering
  const applyCustomValidation = (fieldIndex, validationId, fieldKey) => {
    logger.entry("applyCustomValidation", "Applying custom validation", { fieldIndex, validationId, fieldKey });
    
    const validation = customValidations.find(v => v.id === validationId);
    if (!validation) {
      logger.warn("applyCustomValidation", "Validation not found", { validationId });
      return;
    }
    
    // Copy validation rules and reference to the specific advanced option field
    const field = formConfig.fields[fieldIndex];
    
    // Create complete validation object with all JSON data
    const completeValidationJson = {
      id: validation.id,
      name: validation.name,
      type: validation.type,
      description: validation.description,
      conditions: validation.conditions,
      thenAction: validation.thenAction,
      elseAction: validation.elseAction,
      version: validation.version,
      createdAt: validation.createdAt,
      updatedAt: validation.updatedAt,
      _reference: {
        source: "custom",
        validationId: validation.id,
        appliedAt: new Date().toISOString(),
        appName: appName
      }
    };
    
    const updatedField = {
      ...field,
      advancedOptions: {
        ...field.advancedOptions,
        // Store complete validation JSON object instead of just ID
        [fieldKey]: completeValidationJson,
        // Also keep in additionalValidations array for backward compatibility and bulk updates
        additionalValidations: [
          ...(field.advancedOptions?.additionalValidations || []).filter(v => v.id !== validation.id),
          {
            ...completeValidationJson,
            fieldKey: fieldKey // Track which field this validation applies to
          }
        ]
      }
    };
    
    const newFields = [...formConfig.fields];
    newFields[fieldIndex] = updatedField;
    onUpdateForm({ ...formConfig, fields: newFields });
    
    logger.info("applyCustomValidation", "Custom validation with complete JSON applied successfully", { 
      fieldIndex, 
      validationId, 
      fieldKey,
      hasCompleteJson: !!updatedField.advancedOptions[fieldKey],
      jsonSize: JSON.stringify(completeValidationJson).length
    });
  };
  // End of fix by Claude on 2025-11-12 - Complete validation JSON now embedded in form field
  // End of custom validation handlers

  const getTriggerDisplay = (action) => {
    const triggerType = action.triggerType || 'button';
    
    switch (triggerType) {
      case 'button':
        return `🔘 Button: "${action.triggerLabel || 'Click Me'}"`;
      case 'link':
        return `🔗 Link: "${action.triggerLabel || 'Click here'}"`;
      case 'icon':
        return `🎨 Icon: ${action.triggerIcon || '❓'}`;
      case 'component':
        return `📦 Component ${action.triggerEvent || 'onClick'}`;
      default:
        return '🔘 Button';
    }
  };

  return (
    <div style={{
      height: '100%',
      padding: '20px',
      backgroundColor: '#FFFFFF',
      borderRight: '1px solid #E5E7EB',
      overflow: 'auto'
    }}>
      <div style={{ marginBottom: '24px' }}>
        <h3 style={{
          margin: '0 0 16px',
          fontSize: '16px',
          fontWeight: '700',
          color: '#111827'
        }}>
          📋 Form Configuration
        </h3>

        <div style={{
          display: 'grid',
          gap: '12px',
          padding: '16px',
          backgroundColor: '#F9FAFB',
          borderRadius: '8px',
          border: '1px solid #E5E7EB',
          marginBottom: '20px'
        }}>
          <div>
            <label style={{
              display: 'block',
              fontSize: '12px',
              fontWeight: '600',
              color: '#374151',
              marginBottom: '4px'
            }}>
              Form Title
            </label>
            <input
              type="text"
              value={formConfig.title}
              onChange={(e) => updateFormField('title', e.target.value)}
              style={{
                width: '100%',
                padding: '8px 10px',
                fontSize: '13px',
                border: '1px solid #D1D5DB',
                borderRadius: '6px',
                backgroundColor: '#FFFFFF'
              }}
            />
          </div>

          <div>
            <label style={{
              display: 'block',
              fontSize: '12px',
              fontWeight: '600',
              color: '#374151',
              marginBottom: '4px'
            }}>
              Description
            </label>
            <textarea
              value={formConfig.description}
              onChange={(e) => updateFormField('description', e.target.value)}
              rows={2}
              style={{
                width: '100%',
                padding: '8px 10px',
                fontSize: '13px',
                border: '1px solid #D1D5DB',
                borderRadius: '6px',
                backgroundColor: '#FFFFFF',
                resize: 'vertical'
              }}
            />
          </div>

          <div>
            <label style={{
              display: 'block',
              fontSize: '12px',
              fontWeight: '600',
              color: '#374151',
              marginBottom: '4px'
            }}>
              Submit Button Label
            </label>
            <input
              type="text"
              value={formConfig.submitLabel}
              onChange={(e) => updateFormField('submitLabel', e.target.value)}
              style={{
                width: '100%',
                padding: '8px 10px',
                fontSize: '13px',
                border: '1px solid #D1D5DB',
                borderRadius: '6px',
                backgroundColor: '#FFFFFF'
              }}
            />
          </div>
        </div>
      </div>

      <div style={{ marginBottom: '24px' }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: '12px'
        }}>
          <h3 style={{
            margin: 0,
            fontSize: '16px',
            fontWeight: '700',
            color: '#111827'
          }}>
            ⚡ Form Actions
          </h3>
          <button 
            type="button"
            onClick={() => {
              setEditingActionIndex(null);
              setEditingActionType(null);
              setEditingActionConfig(null);
              setShowActionSelector(true);
            }}
            style={{
              padding: '6px 12px',
              fontSize: '12px',
              fontWeight: '600',
              color: '#FFFFFF',
              backgroundColor: '#8B5CF6',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer'
            }}
          >
            ➕ Add Action
          </button>
        </div>

        {formConfig.actions && formConfig.actions.length > 0 ? (
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '8px',
            padding: '12px',
            backgroundColor: '#F9FAFB',
            borderRadius: '8px',
            border: '1px solid #E5E7EB'
          }}>
            {formConfig.actions.map((action, index) => {
              // Fixed by Claude on 2025-11-23 - Handle actions without actionRegistry
              const actionName = action.actionName || action.action || 'Unknown Action';
              const actionIcon = action.actionIcon || '⚡';
              const actionSummary = action.description || action.summary || `${actionName} action`;

              return (
                <div 
                  key={index} 
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '6px',
                    padding: '12px',
                    backgroundColor: '#FFFFFF',
                    borderRadius: '6px',
                    border: '1px solid #E5E7EB'
                  }}
                >
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: '24px',
                      height: '24px',
                      backgroundColor: '#F3F4F6',
                      borderRadius: '4px',
                      fontSize: '10px',
                      fontWeight: '600',
                      color: '#6B7280'
                    }}>
                      {index + 1}
                    </div>
                    <div style={{ fontSize: '16px' }}>{actionIcon}</div>
                    <div style={{ flex: 1 }}>
                      <div style={{
                        fontSize: '13px',
                        fontWeight: '600',
                        color: '#111827'
                      }}>
                        {actionName}
                      </div>
                      <div style={{ fontSize: '11px', color: '#6B7280' }}>
                        {actionSummary}
                      </div>
                    </div>
                    <div style={{ display: 'flex', gap: '4px' }}>
                      <button 
                        type="button"
                        onClick={() => moveAction(index, -1)}
                        disabled={index === 0}
                        style={{
                          padding: '4px 8px',
                          fontSize: '12px',
                          backgroundColor: 'transparent',
                          border: '1px solid #D1D5DB',
                          borderRadius: '4px',
                          cursor: index === 0 ? 'not-allowed' : 'pointer',
                          color: index === 0 ? '#D1D5DB' : '#6B7280'
                        }}
                      >
                        ↑
                      </button>
                      <button 
                        type="button"
                        onClick={() => moveAction(index, 1)}
                        disabled={index === formConfig.actions.length - 1}
                        style={{
                          padding: '4px 8px',
                          fontSize: '12px',
                          backgroundColor: 'transparent',
                          border: '1px solid #D1D5DB',
                          borderRadius: '4px',
                          cursor: index === formConfig.actions.length - 1 ? 'not-allowed' : 'pointer',
                          color: index === formConfig.actions.length - 1 ? '#D1D5DB' : '#6B7280'
                        }}
                      >
                        ↓
                      </button>
                      <button 
                        type="button"
                        onClick={() => editAction(index)}
                        style={{
                          padding: '4px 8px',
                          fontSize: '12px',
                          backgroundColor: 'transparent',
                          border: '1px solid #D1D5DB',
                          borderRadius: '4px',
                          cursor: 'pointer',
                          color: '#6B7280'
                        }}
                      >
                        ✏️
                      </button>
                      <button 
                        type="button"
                        onClick={() => removeAction(index)}
                        style={{
                          padding: '4px 8px',
                          fontSize: '12px',
                          backgroundColor: 'transparent',
                          border: '1px solid #FCA5A5',
                          borderRadius: '4px',
                          cursor: 'pointer',
                          color: '#DC2626'
                        }}
                      >
                        🗑️
                      </button>
                    </div>
                  </div>

                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px',
                    paddingLeft: '32px',
                    fontSize: '11px',
                    color: '#6B7280'
                  }}>
                    <span style={{ fontWeight: '600' }}>Trigger:</span>
                    <span style={{
                      padding: '2px 8px',
                      backgroundColor: '#EDE9FE',
                      color: '#7C3AED',
                      borderRadius: '4px',
                      fontSize: '10px',
                      fontWeight: '600'
                    }}>
                      {getTriggerDisplay(action)}
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <div style={{
            padding: '24px',
            textAlign: 'center',
            backgroundColor: '#F9FAFB',
            borderRadius: '8px',
            border: '1px solid #E5E7EB'
          }}>
            <div style={{ fontSize: '32px', marginBottom: '8px' }}>⚡</div>
            <p style={{
              margin: '0 0 4px',
              fontSize: '13px',
              fontWeight: '600',
              color: '#111827'
            }}>
              No actions configured
            </p>
            <p style={{ margin: 0, fontSize: '12px', color: '#6B7280' }}>
              Actions define what happens on form submit
            </p>
          </div>
        )}
      </div>

      <div>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: '12px'
        }}>
          <h4 style={{
            margin: 0,
            fontSize: '14px',
            fontWeight: '700',
            color: '#111827'
          }}>
            Form Fields ({formConfig.fields.length})
          </h4>
          <button
            onClick={addField}
            style={{
              padding: '6px 12px',
              fontSize: '12px',
              fontWeight: '600',
              color: '#FFFFFF',
              backgroundColor: '#10B981',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer'
            }}
          >
            ➕ Add Field
          </button>
        </div>

        <div style={{
          border: '1px solid #E5E7EB',
          borderRadius: '8px',
          backgroundColor: '#FFFFFF',
          overflow: 'hidden'
        }}>
          <div style={{
            display: 'grid',
            gridTemplateColumns: '2fr 1.5fr 1.5fr 70px 80px 60px 40px',
            gap: '8px',
            padding: '8px 12px',
            backgroundColor: '#F9FAFB',
            borderBottom: '1px solid #E5E7EB',
            fontSize: '11px',
            fontWeight: '600',
            color: '#6B7280'
          }}>
            <div>LABEL</div>
            <div>ID</div>
            <div>TYPE</div>
            <div>REQUIRED</div>
            <div>ADVANCED</div>
            <div>ORDER</div>
            <div></div>
          </div>

          {formConfig.fields.map((field, index) => {
            const selectedValidation = SMART_FIELD_TYPES.find(v => v.value === (field.smartFieldType || field.type));
            
            return (
              <div
                key={field.id}
                style={{
                  display: 'grid',
                  gridTemplateColumns: '2fr 1.5fr 1.5fr 70px 80px 60px 40px',
                  gap: '8px',
                  padding: '12px',
                  borderBottom: index < formConfig.fields.length - 1 ? '1px solid #F3F4F6' : 'none',
                  alignItems: 'center'
                }}
              >
                <input
                  type="text"
                  value={field.label}
                  onChange={(e) => {
                    e.persist();
                    updateField(index, 'label', e.target.value);
                  }}
                  style={{
                    padding: '6px 8px',
                    fontSize: '12px',
                    border: '1px solid #D1D5DB',
                    borderRadius: '4px',
                    width: '100%'
                  }}
                />

                <input
                  type="text"
                  value={field.id}
                  readOnly
                  style={{
                    padding: '6px 8px',
                    fontSize: '12px',
                    border: '1px solid #E5E7EB',
                    borderRadius: '4px',
                    backgroundColor: '#F9FAFB',
                    color: '#6B7280',
                    width: '100%'
                  }}
                />

                <div style={{ position: 'relative' }}>
                  <select
                    value={field.smartFieldType || 'mudumbai_textOnly'}
                    onChange={(e) => updateField(index, 'smartFieldType', e.target.value)}
                    onMouseEnter={() => setTooltipVisible({ ...tooltipVisible, [index]: true })}
                    onMouseLeave={() => setTooltipVisible({ ...tooltipVisible, [index]: false })}
                    style={{
                      padding: '6px 8px',
                      fontSize: '12px',
                      border: '1px solid #D1D5DB',
                      borderRadius: '4px',
                      width: '100%',
                      cursor: 'pointer'
                    }}
                  >
                    {SMART_FIELD_TYPES.map(validation => (
                      <option key={validation.value} value={validation.value}>
                        {validation.label}
                      </option>
                    ))}
                  </select>
                  
                  {tooltipVisible[index] && selectedValidation?.tooltip && (
                    <div style={{
                      position: 'absolute',
                      bottom: '100%',
                      left: '0',
                      marginBottom: '6px',
                      padding: '6px 10px',
                      backgroundColor: '#1F2937',
                      color: '#FFFFFF',
                      fontSize: '11px',
                      borderRadius: '4px',
                      whiteSpace: 'normal',
                      zIndex: 1000,
                      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                      maxWidth: '250px'
                    }}>
                      {selectedValidation.tooltip}
                      <div style={{
                        position: 'absolute',
                        top: '100%',
                        left: '20px',
                        width: 0,
                        height: 0,
                        borderLeft: '5px solid transparent',
                        borderRight: '5px solid transparent',
                        borderTop: '5px solid #1F2937'
                      }}></div>
                    </div>
                  )}
                </div>

                <label style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer'
                }}>
                  <input
                    type="checkbox"
                    checked={field.required || false}
                    onChange={(e) => updateField(index, 'required', e.target.checked)}
                    style={{
                      width: '14px',
                      height: '14px',
                      accentColor: '#3B82F6'
                    }}
                  />
                </label>

                <button
                  type="button"
                  onClick={() => openAdvancedPopup(index)}
                  style={{
                    padding: '4px 10px',
                    fontSize: '11px',
                    fontWeight: '600',
                    color: '#3B82F6',
                    backgroundColor: '#EFF6FF',
                    border: '1px solid #BFDBFE',
                    borderRadius: '4px',
                    cursor: 'pointer'
                  }}
                >
                  More →
                </button>

                <div style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '2px',
                  alignItems: 'center'
                }}>
                  <button
                    onClick={() => index > 0 && moveField(index, index - 1)}
                    disabled={index === 0}
                    style={{
                      padding: '2px 4px',
                      fontSize: '10px',
                      border: 'none',
                      backgroundColor: 'transparent',
                      cursor: index === 0 ? 'not-allowed' : 'pointer',
                      color: index === 0 ? '#D1D5DB' : '#6B7280'
                    }}
                  >
                    ▲
                  </button>
                  <button
                    onClick={() => index < formConfig.fields.length - 1 && moveField(index, index + 1)}
                    disabled={index === formConfig.fields.length - 1}
                    style={{
                      padding: '2px 4px',
                      fontSize: '10px',
                      border: 'none',
                      backgroundColor: 'transparent',
                      cursor: index === formConfig.fields.length - 1 ? 'not-allowed' : 'pointer',
                      color: index === formConfig.fields.length - 1 ? '#D1D5DB' : '#6B7280'
                    }}
                  >
                    ▼
                  </button>
                </div>

                <button
                  onClick={() => removeField(index)}
                  style={{
                    padding: '4px',
                    fontSize: '12px',
                    backgroundColor: 'transparent',
                    border: '1px solid #FCA5A5',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    color: '#DC2626'
                  }}
                >
                  🗑️
                </button>
              </div>
            );
          })}

          {formConfig.fields.length === 0 && (
            <div style={{
              padding: '24px',
              textAlign: 'center',
              color: '#9CA3AF',
              fontSize: '13px'
            }}>
              No fields added yet
            </div>
          )}
        </div>
      </div>

      {showAdvancedPopup && activeFieldIndex !== null && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 10000
        }}
        onClick={() => setShowAdvancedPopup(false)}
        >
          <div 
            style={{
              backgroundColor: '#FFFFFF',
              borderRadius: '12px',
              padding: '24px',
              maxWidth: '500px',
              width: '90%',
              maxHeight: '80vh',
              overflow: 'auto',
              boxShadow: '0 25px 50px rgba(0, 0, 0, 0.25)'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              marginBottom: '20px'
            }}>
              <h3 style={{
                margin: 0,
                fontSize: '16px',
                fontWeight: '700',
                color: '#111827'
              }}>
                Advanced Options - {formConfig.fields[activeFieldIndex]?.label}
              </h3>
              <button
                onClick={() => setShowAdvancedPopup(false)}
                style={{
                  padding: '4px 8px',
                  fontSize: '16px',
                  backgroundColor: 'transparent',
                  border: 'none',
                  cursor: 'pointer',
                  color: '#6B7280'
                }}
              >
                ✕
              </button>
            </div>

            {/* Fixed by Claude on 2025-11-09 23:05:00 - Using reusable function to ensure perfect sync */}
            {renderValidationDropdown('visibleOnlyWhen', 'Visible only when', 'visibility', false)}
            {renderValidationDropdown('captureOnlyWhen', 'Capture only when (Required)', 'required', true)}
            {renderValidationDropdown('makeReadOnlyWhen', 'Make Read Only when', 'readonly', false)}

            {/* Removed by Claude on 2025-11-10 - TEST section removed, not needed in production UI */}

            {/* Added by Claude on 2025-11-23 - Field Validation Rules Section */}
            <div style={{
              marginBottom: '16px',
              padding: '12px',
              backgroundColor: '#EFF6FF',
              borderRadius: '8px',
              border: '1px solid #BFDBFE'
            }}>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                marginBottom: '12px'
              }}>
                <h4 style={{
                  margin: 0,
                  fontSize: '13px',
                  fontWeight: '600',
                  color: '#1E40AF'
                }}>
                  ⚙️ Field Validation Rules
                </h4>
                <button
                  type="button"
                  onClick={handleAddFieldValidation}
                  style={{
                    padding: '4px 10px',
                    fontSize: '12px',
                    fontWeight: '600',
                    color: '#3B82F6',
                    backgroundColor: '#FFFFFF',
                    border: '1px solid #3B82F6',
                    borderRadius: '4px',
                    cursor: 'pointer'
                  }}
                >
                  + Add Rule
                </button>
              </div>
              
              <FieldValidationList
                rules={formConfig.fields[activeFieldIndex]?.fieldValidationRules || []}
                onEdit={handleEditFieldValidation}
                onDelete={handleDeleteFieldValidation}
                onToggleStatus={handleToggleFieldValidationStatus}
                compact={true}
              />
            </div>
            {/* End of Field Validation Rules Section */}

            <div style={{
              padding: '12px',
              backgroundColor: '#F9FAFB',
              borderRadius: '6px',
              border: '1px dashed #D1D5DB',
              textAlign: 'center',
              marginBottom: '16px'
            }}>
              <p style={{
                margin: '0 0 8px',
                fontSize: '12px',
                color: '#6B7280'
              }}>
                Need custom business validation?
              </p>
              <div style={{ display: 'flex', gap: '8px', justifyContent: 'center' }}>
                <button
                  type="button"
                  onClick={handleOpenValidationForm}
                  style={{
                    padding: '6px 12px',
                    fontSize: '12px',
                    fontWeight: '600',
                    color: '#059669',
                    backgroundColor: '#ECFDF5',
                    border: '1px solid #A7F3D0',
                    borderRadius: '4px',
                    cursor: 'pointer'
                  }}
                >
                  + Add New
                </button>
                <button
                  type="button"
                  onClick={() => navigate('/validations')}
                  style={{
                    padding: '6px 12px',
                    fontSize: '12px',
                    fontWeight: '600',
                    color: '#3B82F6',
                    backgroundColor: '#EFF6FF',
                    border: '1px solid #BFDBFE',
                    borderRadius: '4px',
                    cursor: 'pointer'
                  }}
                >
                  Manage All →
                </button>
              </div>
            </div>
            {/* End of custom validation section */}

            <div style={{
              display: 'flex',
              gap: '8px',
              justifyContent: 'flex-end'
            }}>
              <button
                onClick={() => setShowAdvancedPopup(false)}
                style={{
                  padding: '8px 16px',
                  fontSize: '13px',
                  fontWeight: '600',
                  color: '#6B7280',
                  backgroundColor: '#F9FAFB',
                  border: '1px solid #E5E7EB',
                  borderRadius: '6px',
                  cursor: 'pointer'
                }}
              >
                Cancel
              </button>
              <button
                onClick={() => setShowAdvancedPopup(false)}
                style={{
                  padding: '8px 16px',
                  fontSize: '13px',
                  fontWeight: '600',
                  color: '#FFFFFF',
                  backgroundColor: '#3B82F6',
                  border: 'none',
                  borderRadius: '6px',
                  cursor: 'pointer'
                }}
              >
                Apply
              </button>
            </div>
          </div>
        </div>
      )}

      {/* REMOVED: ActionSystem ActionSelector (2025-11-20) */}
      {/* {showActionSelector && (
        <ActionSelector
          onActionAdd={editingActionIndex !== null ? saveEditedAction : addAction}
          onClose={editingActionIndex !== null ? cancelEdit : () => setShowActionSelector(false)}
          existingActions={formConfig.actions || []}
          editMode={editingActionIndex !== null}
          editActionType={editingActionType}
          editActionConfig={editingActionConfig}
        />
      )} */}

      {/* Added by Claude on 2025-11-09 22:01:00 - Validation Config Form Modal */}
      {showValidationForm && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 10001
        }}>
          <div style={{
            backgroundColor: 'white',
            borderRadius: '8px',
            maxWidth: '700px',
            width: '90%',
            maxHeight: '90vh',
            overflow: 'auto',
            boxShadow: '0 25px 50px rgba(0, 0, 0, 0.25)'
          }}>
            <ValidationConfigForm
              validation={null}
              formFields={formConfig.fields || []}
              onSave={handleSaveCustomValidation}
              onCancel={handleCancelValidationForm}
              mode="add"
            />
          </div>
        </div>
      )}
      {/* End of Validation Config Form Modal */}

      {/* Added by Claude on 2025-11-23 - Field Validation Builder Modal */}
      {showFieldValidationBuilder && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 10002
        }}>
          <div style={{
            backgroundColor: 'white',
            borderRadius: '12px',
            maxWidth: '900px',
            width: '95%',
            maxHeight: '90vh',
            overflow: 'auto',
            boxShadow: '0 25px 50px rgba(0, 0, 0, 0.25)'
          }}>
            <FieldValidationBuilder
              formFields={formConfig.fields || []}
              existingRule={editingFieldValidation}
              onSave={handleSaveFieldValidation}
              onCancel={handleCancelFieldValidationBuilder}
            />
          </div>
        </div>
      )}
      {/* End of Field Validation Builder Modal */}
    </div>
  );
};

// End of FormConfigPanel - Updated by Claude on 2025-11-09 22:01:00

export default FormConfigPanel;